import Constant from 'BASE/common/lotteryConstant';

export const GameTag = {
    Normal: 0,
    Hot: 1,
    New: 2,
};

export function getGameTag(type) {
    switch (type) {
        case Constant.LotteryGameHotNewState.HOT:
            return GameTag.Hot;
        case Constant.LotteryGameHotNewState.NEW:
            return GameTag.New;
        default:
            return GameTag.Normal;
    }
}
// 無法由後台控制的彩種(VR/外接)在這裡做添加
// 各商戶分別在自己的gameTag.js改寫HotVRGames跟NewVRGames
let HotVRGames = [];
let NewVRGames = [];

export function setHotVRGames(games) {
    HotVRGames = games;
}

export function setNewVRGames(games) {
    NewVRGames = games;
}

export { HotVRGames, NewVRGames };

export function getVRGameTag(gameCode) {
    if (HotVRGames.indexOf(gameCode) >= 0) {
        return GameTag.Hot;
    }
    else if (NewVRGames.indexOf(gameCode) >= 0) {
        return GameTag.New;
    }
    return GameTag.Normal;
}

